<template>
  <div>
    <form @submit.prevent="handleOk">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="md"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Outlet Price
          </span>
        </div>
        <div>
          <b-container>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input v-model="obj.outletCode" name="outletCode" type="text" />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Order Type</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('outletType')}">
                <b-form-select
                  v-model="obj.orderType"
                  v-validate="'required|alpha_num|order_type'"
                  name="outletType"
                  :options="getOutletPriceConfig"
                />
                <small>{{ errors.first('outletType') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Price Type</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('priceType')}">
                <b-form-input v-model="obj.priceType" name="priceType" type="text" />
                <small>{{ errors.first('priceType') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },

  computed: {
    getOutletPriceConfig() {
      return _.values(this.$store.getters.GetOutletPriceConfig.ORDER_TYPES);
    }
  },

  created() {
    this.$store.dispatch('GetOutletPriceConfig');
  },

  methods: {
    // add and update records
    handleOk(evt) {
      this.$validator.validate().then(valid => {
        if (valid) {
          evt.preventDefault();
          if (this.input === null) {
            this.$store
              .dispatch('CreateOutletPrice', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateOutletPrice', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is updated'
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          outletCode: '',
          orderType: '',
          priceType: ''
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
